export default '6.23.3';